import React from 'react';
import { Link } from 'react-router-dom';
import { MapPinIcon, PhoneIcon, EnvelopeIcon } from '@heroicons/react/24/outline';
import { CONTACT_INFO, BUSINESS_INFO } from '../constants/contact';

export default function Footer() {
  return (
    <footer className="bg-neutral-900 text-neutral-100">
      <div className="mx-auto max-w-7xl px-6 py-12 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">          {/* Brand */}
          <div className="space-y-4">
            <h3 className="text-xl font-display font-bold text-white">{BUSINESS_INFO.name}</h3>
            <p className="text-neutral-300 text-sm leading-relaxed">
              {BUSINESS_INFO.description}
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold text-white">Quick Links</h4>            <nav className="space-y-2">
              <Link to="/rooms" className="block text-neutral-300 hover:text-white transition-colors text-sm">
                Rooms
              </Link>
              <Link to="/services" className="block text-neutral-300 hover:text-white transition-colors text-sm">
                Services
              </Link>
              <Link to="/booking" className="block text-neutral-300 hover:text-white transition-colors text-sm">
                Book Now
              </Link>              <Link to="/gallery" className="block text-neutral-300 hover:text-white transition-colors text-sm">
                Gallery
              </Link>
              <a href="/admin/" className="block text-neutral-300 hover:text-white transition-colors text-sm">
                Admin
              </a>
            </nav>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold text-white">Contact Us</h4>
            <div className="space-y-3">              <div className="flex items-start space-x-3">
                <MapPinIcon className="h-5 w-5 text-primary-400 mt-0.5 flex-shrink-0" />
                <span className="text-neutral-300 text-sm">
                  {CONTACT_INFO.address.village}, {CONTACT_INFO.address.district}<br />
                  {CONTACT_INFO.address.country}
                </span>
              </div>
              <div className="flex items-center space-x-3">
                <PhoneIcon className="h-5 w-5 text-primary-400 flex-shrink-0" />
                <span className="text-neutral-300 text-sm">{CONTACT_INFO.phone}</span>
              </div>
              <div className="flex items-center space-x-3">
                <EnvelopeIcon className="h-5 w-5 text-primary-400 flex-shrink-0" />
                <span className="text-neutral-300 text-sm">{CONTACT_INFO.email}</span>
              </div>
            </div>
          </div>
        </div>        <div className="mt-12 pt-8 border-t border-neutral-800">
          <div className="text-center space-y-2">
            <p className="text-sm text-neutral-400">
              Website made by{' '}
              <a 
                href="https://nabindhakal.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-primary-400 hover:text-primary-300 transition-colors"
              >
                Nabin Dhakal
              </a>
            </p>
            <p className="text-sm text-neutral-400">
              © {new Date().getFullYear()} {BUSINESS_INFO.name}. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
